export default __webpack_public_path__ + "static/media/reports.2a596fca.jpg";